/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let KitchenCollectionProductsImport;

/** ****************************
 * Kitchen Collection Product *
 ***************************** */
export const KitchenCollectionProductsLoad = () => import(
  /*
    webpackPrefetch: true,
    webpackChunkName: "kitchen-collection-products"
  */
  './subcomponents/KitchenCollectionProducts')
  .then((module) => {
    const { KitchenCollectionProducts } = module;

    KitchenCollectionProductsImport = (props) => {
      return (
        <QueryProvider dataSource="searchNav" defaultVariables={props.qctx.defaultVariables.current} cacheKey="kitchen-collection-products">
          <KitchenCollectionProducts {...props} />
        </QueryProvider>
      );
    };
  });

export const KitchenCollectionProducts = ssr
  ? __webpack_require__(require.resolveWeak('./subcomponents/KitchenCollectionProducts')).KitchenCollectionProducts
  : (props) => <KitchenCollectionProductsImport {...props} />;